/*
ABOUT >>
THIS INPUT USED FOR CREATE BUTTON ON LIST AND WHEN CLICK ON BUTTON THEN CREATE POPUP AND RENDER LIST ACCORDING TO ROUTE
FULLY DYNAMIC  

ACTIVE >>
ITS IN RUNNING POSITION 

UPDATES >>
IT WILL BE UPDATE TO MAKE MORE ENHANCE CODE 
*/

import React ,{useState,useEffect} from 'react';
import SecurityService from  '../security/security.service.js'
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import './dynamic-v-7.scss'
import SecureComponent  from '../security/secure.component.js';
import SaleInvoiceInput from '../sale-invoice/sale-invoice-list.js';
// import Shop from '../shop/shop';

// import YarnPurchaseContractDeliveryScheduleList from '../yarn-contract-delivery-schedule/yarn-contract-delivery-schedule-list.js'
// import FabricPurchaseContractDeliveryScheduleList from '../fabric-purchase-contract-delivery-schedule/fabric-purchase-contract-delivery-schedule-list.js'
// import ProjectionPlanning from '../projection-planning/projection-planning-list.js'
// import YarnTransactionsYarnContract from '../yarn/yarn-transactions/yarn-transactions-get-data.js'
// import GetExportOrderYarnRequiredForDyeingList from '../yarn/yarn-dyeing-contract/yarn-dyeing-contract-get-data.js'
// import YarnTransactionsYarnWeaver from '../yarn/yarn-transactions/yarn-weaver-get-data.js'
// import GetBills from '../voucher/get-bills.js'
// import BrandVendor from '../brand-vendor/brand-vendor';
// import UnitOfMeasurement from '../unit-of-measurement/unit-of-measurement';

// =====================> GREIGE OPENING START IMPORTING<========================
// import GreigeOpeningGetDataList from '../greige/greige-opening/greige-opening-get-data.js';
// =====================> GREIGE OPENING END IMPORTING<========================

// =====================> DYEING OPENING BALANCE START IMPORTING<========================
// import DyeingOpeningBalanceGetDataList from '../dyeing/dyeing-opening-balance/dyeing-opening-balance-get-data.js';
// =====================> DYEING OPENING BALANCE END IMPORTING<========================

// =====================> DYEING CONTRACT START IMPORTING<========================
// import DyeingContractGetDataList from '../dyeing/dyeing-contract/dyeing-contract-get-data.js';
// =====================> DYEING CONTRACT END IMPORTING<========================


// =====================> STITCHING OPENING START IMPORTING<========================
// import StitchingOpeningGetDataList from '../stitching/stitching-opening/stitching-opening-get-data.js';
// =====================> STITCHING OPENING END IMPORTING<========================

// =====================> STITCHING CONTRACT START IMPORTING<========================
// import StitchingContractGetDataList from '../stitching/stitching-contract/stitching-contract-get-data.js';
// =====================> STITCHING CONTRACT END IMPORTING<========================

// =====================> SHEARING CONTRACT START IMPORTING<========================
// import ShearingContractGetDataList from '../shearing/shearing-contract/shearing-contract-get-data.js';
// =====================> SHEARING CONTRACT END IMPORTING<========================

// =====================> STITCHING TRANSACTIONS  START IMPORTING<========================
// import StitchingTransactionGetDataList from '../stitching/stitching-transactions/stitching-transactions-get-data.js';
// =====================> STITCHING TRANSACTIONS  END IMPORTING<========================


// =====================> SHEARING TRANSACTIONS  START IMPORTING<========================
// import ShearingTransactionGetDataList from '../shearing/shearing-transactions/shearing-transactions-get-data.js';
// =====================> SHEARING TRANSACTIONS  END IMPORTING<========================

// =====================> ACCESSORY TRANSACTIONS  START IMPORTING<========================
// import AccessoryTransactionGetDataList from '../accessory/accessory-transactions/accessory-transactions-get-data.js';
// =====================> ACCESSORY TRANSACTIONS  END IMPORTING<========================
const IrtizaDynamicListButtonDialog = (props) => {
    console.log(props)
    const [showAddNewDialog, setShowAddNewDialog] = useState(false);
    const [dialogType, setDialogType] = useState('');
    const [addNewClicked, setAddNewClicked] = useState(false); 


    useEffect(()=>{
     
      
    },[])
    const onAddNewClick = (type) => {
        console.log('type: ', type);
        if(type !== ''){
          setAddNewClicked(true)
          setShowAddNewDialog(false);
          setDialogType(type);
          setTimeout(() => { 
            setShowAddNewDialog(true);
          },100)
        }
      };

      const header = () => {
        console.log(props)
        if(showAddNewDialog) {
          return <div className="dialog-header heading" >
            {SecurityService.canUserAccess(props.Security)['List'] ? props.InputTitle:null}
            </div>;
        }
        else {
          return <div></div>;
        }
      };
    
      const onClose = () => {
        setAddNewClicked(false)
        setShowAddNewDialog(false);
        switch(dialogType){
          case 'ProducdtCategory':
            props.OnClosed()
          break;
          default:
            props.OnClosed()
          break;
        } 
      }
    
      const footerTemplate = () => {
        if(showAddNewDialog){
          return (<div id={props.Route}>
            <button id="btnSave"  className={`e-control e-btn e-primary ${props.Route}`} data-ripple="true" onClick={onClose}>Close</button>
          </div>);
        }
        else{<h3 style={{ textAlign:'center', width: '80%' }}></h3>
           return (<></>);
        }
      };
    
      const contentTemplate = (prop) => {
        console.log('props: ', props);
        if(showAddNewDialog){
        if(SecurityService.canUserAccess(props.Security)['List']){
          switch(props.Route){
          //  case 'DeliverySchedule':
          //             return (
          //               <div>
          //                 <FabricPurchaseContractDeliveryScheduleList
          //           {...props.SelectedRow}
          //           name={props.Security}
          //           IsDialog={true}
          //       ></FabricPurchaseContractDeliveryScheduleList>
          //               </div>
          //             )
          //           break;
          //           case 'YarnDeliverySchedule':
          //             return (
          //               <div>
          //                 <YarnPurchaseContractDeliveryScheduleList
          //           {...props.SelectedRow}
          //           name={props.Security}
          //           IsDialog={true}
          //       ></YarnPurchaseContractDeliveryScheduleList>
          //               </div>
          //             )
          //           break;
          //           case 'Projection':
          //             return (
          //               <div>
          //        <ProjectionPlanning
          //           selectedRow={props.SelectedRow}
          //           name={props.Security}
          //           IsDialog={true}
          //       ></ProjectionPlanning>
          //               </div>
          //             )
          //           case 'GetExportOrderYarnRequiredForDyeing':
          //             return (
          //               <div>
          //        <GetExportOrderYarnRequiredForDyeingList
          //             selectedRow={props.SelectedRow}
          //             name={props.Security}
          //             IsDialog={true}
          //             sendDetails={props.sendDetails}
          //             MainData={props.MainData}
          //         ></GetExportOrderYarnRequiredForDyeingList>
          //               </div>
          //             )
          //           case 'YarnTransactionsYarnContract':
          //             return (
          //               <div>
          //              <YarnTransactionsYarnContract
          //             selectedRow={props.SelectedRow}
          //             name={props.Security}
          //             IsDialog={true}
          //             sendDetails={props.sendDetails}
          //             ActivityType={props.ActivityType}
          //             ActivityTypeID={props.ActivityTypeID}
          //             ActivityTypeTitle={props.ActivityTypeTitle}
          //             MainData={props.MainData}
          //         ></YarnTransactionsYarnContract>
        
          //               </div>
          //             )
          //           case 'YarnTransactionsYarnWeaver':
          //             return (
          //               <div>
          //              <YarnTransactionsYarnWeaver
          //             selectedRow={props.SelectedRow}
          //             name={props.Security}
          //             IsDialog={true}
          //             sendDetails={props.sendDetails}
          //             ActivityType={props.ActivityType}
          //             ActivityTypeID={props.ActivityTypeID}
          //             ActivityTypeTitle={props.ActivityTypeTitle}
          //             MainData={props.MainData}
          //         ></YarnTransactionsYarnWeaver>
        
          //               </div>
          //             )
          //           case 'GreigeOpeningGetData':
          //             return (
          //               <div>
          //              <GreigeOpeningGetDataList
          //             selectedRow={props.SelectedRow}
          //             name={props.Security}
          //             IsDialog={true}
          //             sendDetails={props.sendDetails}
          //             ActivityType={props.ActivityType}
          //             ActivityTypeID={props.ActivityTypeID}
          //             ActivityTypeTitle={props.ActivityTypeTitle}
          //             MainData={props.MainData}
          //         ></GreigeOpeningGetDataList>
        
          //               </div>
          //             )
          //           case 'DyeingOpeningBalanceGetData':
          //             return (
          //               <div>
          //              <DyeingOpeningBalanceGetDataList
          //             selectedRow={props.SelectedRow}
          //             name={props.Security}
          //             IsDialog={true}
          //             sendDetails={props.sendDetails}
          //             ActivityType={props.ActivityType}
          //             ActivityTypeID={props.ActivityTypeID}
          //             ActivityTypeTitle={props.ActivityTypeTitle}
          //             MainData={props.MainData}
          //         ></DyeingOpeningBalanceGetDataList>
        
          //               </div>
          //             )
          //           case 'DyeingContractGetData':
          //             return (
          //               <div>
          //              <DyeingContractGetDataList
          //             selectedRow={props.SelectedRow}
          //             name={props.Security}
          //             IsDialog={true}
          //             sendDetails={props.sendDetails}
          //             MainData={props.MainData}
          //         ></DyeingContractGetDataList>
        
          //               </div>
          //             )
                 
          //           case 'StitchingOpeningGetData':
          //             return (
          //               <div>
          //              <StitchingOpeningGetDataList
          //             selectedRow={props.SelectedRow}
          //             name={props.Security}
          //             IsDialog={true}
          //             sendDetails={props.sendDetails}
          //             MainData={props.MainData}
          //         ></StitchingOpeningGetDataList>
        
          //               </div>
          //             )
                 
          //           case 'StitchingContractGetData':
          //             return (
          //               <div>
          //              <StitchingContractGetDataList
          //             selectedRow={props.SelectedRow}
          //             name={props.Security}
          //             IsDialog={true}
          //             sendDetails={props.sendDetails}
          //             MainData={props.MainData}
          //         ></StitchingContractGetDataList>
        
          //               </div>
          //             )
          //           case 'ShearingContractGetData':
          //             return (
          //               <div>
          //              <ShearingContractGetDataList
          //             selectedRow={props.SelectedRow}
          //             name={props.Security}
          //             IsDialog={true}
          //             sendDetails={props.sendDetails}
          //             MainData={props.MainData}
          //         ></ShearingContractGetDataList>
        
          //               </div>
          //             )
          //           case 'StitchingTransactionGetData':
          //             return (
          //               <div>
          //              <StitchingTransactionGetDataList
          //             selectedRow={props.SelectedRow}
          //             name={props.Security}
          //             IsDialog={true}
          //             ActivityType={props.ActivityType}
          //             ActivityTypeTitle={props.ActivityTypeTitle}
          //             sendDetails={props.sendDetails}
          //             MainData={props.MainData}
          //         ></StitchingTransactionGetDataList>
        
          //               </div>
          //             )
                 
          //           case 'ShearingTransactionGetData':
          //             return (
          //               <div>
          //              <ShearingTransactionGetDataList
          //             selectedRow={props.SelectedRow}
          //             name={props.Security}
          //             IsDialog={true}
          //             ActivityType={props.ActivityType}
          //             ActivityTypeID={props.ActivityTypeID}
          //             ActivityTypeTitle={props.ActivityTypeTitle}
          //             sendDetails={props.sendDetails}
          //             MainData={props.MainData}
          //         ></ShearingTransactionGetDataList>
        
          //               </div>
          //             )
                    case 'FBRInvoice':
                      return window.open("/SaleInvoiceSandbox", "_blank", "noopener,noreferrer");
                 
                          default:
              return(
            <div className="returnlist" style={{textAlign:'center'}}> <SecureComponent name={props.Security} /> </div>
              )
              
          } 

        } 
        else {
          return (
            <div className="returnlist" style={{textAlign:'center'}}> <SecureComponent name={props.Security} /> </div>
          );
        }
        }
      };
    
      
      
    return (
        <div>
          {
            showAddNewDialog == true ?
      (<div className='App' id='targetElement'>
        <DialogComponent
            width={props.Width ?  props.Width : '1200px' }
            height={props.Height ?  props.Height : '1000px' }
            visible={showAddNewDialog}
            close={onClose}
            content={contentTemplate}
            isModal={true}
          
            showCloseIcon={true}
            header={header}
            footerTemplate = {footerTemplate}
            
            zIndex={784465}

          />
        </div>)
        :null}
      {/* <ButtonComponent 
        style={
          {
            ...(props.Color && { color: props.Color }),
            ...(props.BgColor && { backgroundColor: props.BgColor,borderColor:props.BgColor }),
            textWrap:'wrap'
        }
        }
        title={props.Title}
        onClick={ (e) => {
        e.preventDefault();
        onAddNewClick(props.Route);
      }
      }
        >{props.Title}</ButtonComponent> */}
        <button 
          id={props.Id}
          className='e-control e-btn e-primary'
        style={
          {
            ...(props.Color && { color: props.Color }),
            ...(props.BgColor && { backgroundColor: props.BgColor,borderColor:props.BgColor }),
            textWrap:'wrap'
        }
        }
        onBlur={(e)=>{
          if(props?.onBlur){
          props?.onBlur(e,dialogType)
          }
        }}
        
      
        onClick={(e)=>{
          console.log(e)
        e.preventDefault()
        setTimeout(()=>{
          onAddNewClick(props.Route)

          if(props.Route == "FBRInvoice"){
            console.log('FBRInvoice')
          document.querySelectorAll(".FBRInvoice").forEach(btn => btn.click());
        }
          },1000)
      }}
        >
        {props.Title}
        </button>
        </div>
    );
}

export default IrtizaDynamicListButtonDialog;

